import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Motorcycle Safety',
  slug: 'motorcycle-safety',
  category: 'Motorcycle Safety',
  date: '2025-05-16',
  image: '',
  excerpt: 'Scan… Identify… Predict… Decide… Execute',
  body: `Scan… Identify… Predict… Decide… Execute

SIPDE

I learned how to ride a motorcycle when I was 30. It's difficult learning physical things as an adult. Things aren't as intuitive as they used to be, and my intuitions were often wrong.

There is a mnemonic they taught us that helps with defensive driving. It is also a good model for moving forward in life when faced with a crossroads. It's called…

**SIPDE. Scan. Identify. Predict. Decide. Execute.**

I'll write this as a motorcycle safety lesson and let you, the reader, interpret it as a lesson for life.

**Scan**
Scan the road ahead. Look for what's not quite right.

**Identify**
Identify the anomalies. Is there a kid playing soccer on the side of the road? Is that driver up ahead texting?

**Predict**
That ball might go into the road followed by the kid. That driver is gonna swerve.

**Decide**
If a dangerous situation arises, decide what you'll do. It'll involve one or more of the following: change speed (gas or brakes), change direction.

**Execute**
When the thing happens, execute your plan.

**Practical Usage**
Try this model when looking at any situation of uncertainty.`,
}

export default post
